import { wrappingInputRule } from 'prosemirror-inputrules';
import { Node, NodeSpec } from 'prosemirror-model';
import { InputRulesProps } from '../types';
import { BaseNode } from './base/BaseNode';

export class OrderedList extends BaseNode {
  constructor() {
    super('ordered_list');
  }

  get schema(): NodeSpec {
    return {
      attrs: {
        order: {
          default: 1,
          validate: 'number',
        },
      },
      content: 'list_item+',
      group: 'block list',
      parseDOM: [
        {
          tag: 'ol',
          getAttrs: (dom: HTMLElement) => ({
            order: dom.hasAttribute('start') ? parseInt(dom.getAttribute('start') || '1', 10) : 1,
          }),
        },
      ],
      toDOM: (node: Node) =>
        node.attrs.order === 1 ? ['ol', 0] : ['ol', { start: node.attrs.order as number }, 0],
    };
  }

  inputRules({ schema }: InputRulesProps) {
    return [
      wrappingInputRule(
        /^(\d+)\.\s$/,
        schema.nodes.ordered_list,
        (match) => ({ order: +match[1] }),
        (match, node) => node.childCount + node.attrs.order === +match[1]
      ),
    ];
  }
}
